module.exports = __webpack_public_path__ + "img/pr.29878f1d.svg";